export const SPECIAL_UNITS_LABELS = {
  title: "Unidades Especiales",
  messages: {
    selectStation: "Seleccione una estación",
  },
  headers: {
    unit: "Unidad",
    unitType: "Mayorista",
    price: "Precio",
    sale: "Venta Portatil",
    grossSale: "Vta. Bruta",
    netSale: "Vta. Neta",
    profit: "Util. Bruta",
    distributionExpenses: "Gtos. Distrib.",
    adminExpenses: "Gtos. Admón.",
    profitSharing1: "Util. antes ISR 1",
    profitSharing2: "Util. antes ISR 2",
    date: "Fecha Reporte",
    actions: "Acciones",
  },
};

export const INGRESOS_FIELDS = [
  { key: "sale", label: "VENTA" },
  { key: "costSale", label: "COSTO SOBRE VENTA" },
];

export const EGRESOS_FIELDS = [
  { key: "imss", label: "IMSS" },
  { key: "selfConsumption", label: "AUTOCONSUMO" },
  { key: "perceptions", label: "PERCEPCIONES" },
  { key: "cylinderRepair", label: "REPARACION CILINDROS" },
  { key: "portableEquipmentMaintenance", label: "MANTENIMIENTO EQUIPO PORTATIL" },
  { key: "tankAcquisition", label: "ADQUISICION DE TANQUES" },
  { key: "tankAccessories", label: "ACCESORIOS DE TANQUES" },
  { key: "insuranceFinanceFees", label: "CUOTAS SEGUROS Y FINANZAS" },
  { key: "commissions", label: "COMISIONES" },
  { key: "efParticipation", label: "PARTICIPACION DE EF (se suma a utilidad)" },
  { key: "specialPricePromotion", label: "PROMOCION PRECIO ESPECIAL" },
  { key: "christmasBonus", label: "AGUINALDO" },
  { key: "taxes", label: "IMPUESTOS" },
  { key: "claimsTheft", label: "SINIESTROS Y ROBOS" },
  { key: "platformVoucher", label: "VALE ANDEN" },
  { key: "foodVouchersAdvertising", label: "DESPENSAS Y PUBLICIDAD" },
  { key: "floorRights", label: "DERECHO PISO" },
];
